const said = new Set<string>();

/** console.warn, once per distinct message for the life of the page. */
export function warn(message: string): void {
	if (said.has(message)) return;
	said.add(message);
	console.warn(`[@grundfast/dawa-autocomplete] ${message}`);
}

/** For tests: forget which messages were printed. */
export function _resetWarnings(): void {
	said.clear();
}
